module.exports = __webpack_public_path__ + "img/shade-document-scanner.9254962b.svg";